import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/Common/Dialog';
import Ad from 'models/business/Ad';
import classNames from 'classnames';
import { formatDate } from 'tools/date';
import Styles from './index.module.css';

export default function DateModal({
  ad,
  onSubmit,
  onCancel,
}) {
  const [workingAd, setWorkingAd] = useState(ad);
  // eslint-disable-next-line no-unused-vars
  const [startDate] = useState(ad.startDate);

  const dateSelector = useMemo(() => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <input
        style={{
          all: 'unset',
          margin: '0px 15px',
          color: '#455780',
          fontSize: 19,
        }}
        type="date"
        min={formatDate(workingAd.earliestStartingDate)}
        value={formatDate(workingAd.startDate)}
        onChange={(e) => {
          const newAd = workingAd.clone();
          newAd.startDate = new Date(e.target.value);
          setWorkingAd(newAd);
        }}
      />
      <div className={classNames(Styles.shield)} />
    </div>
  ), [workingAd]);

  useEffect(() => {
    const newAd = ad.clone();
    newAd.startDate = newAd.earliestStartingDate;
    setWorkingAd(newAd);
  }, [ad]);

  return (
    <Dialog
      open
      title="請設定開始日期"
      content={(
        <div>
          {dateSelector}
        </div>
      )}
      onSubmit={() => onSubmit(workingAd)}
      onClose={onCancel}
      onCancel={onCancel}
      hideCancel={false}
    />
  );
}

DateModal.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

DateModal.defaultProps = {
  ad: new Ad(),
  onSubmit: () => { },
  onCancel: () => { },
};
